export const imports = {
  description:
    "Initial-data import with dry-run validation, row-level errors, and rollback.",
  importKind: "Import kind",
  csvFile: "CSV file",
  dryRun: "Dry run",
  commit: "Commit import",
  preview: "Preview · {total} rows · {ok} ok",
  errorsCaption: "Import errors",
  noErrors: "No errors",
  noErrorsDesc: "All rows are valid and ready to commit.",
  recent: "Recent imports",
  batchesCaption: "Import batches",
  noImports: "No imports yet",
  noImportsDesc: "Imported batches appear here for audit.",
  column: {
    kind: "Kind",
    file: "File",
    rows: "Rows",
    importedBy: "Imported by",
    row: "Row",
    message: "Message",
  },
  kind: {
    customers: "Customers",
    suppliers: "Suppliers",
    materials: "Materials",
    products: "Products",
    boms: "Product BOMs",
    routings: "Product routings",
    "opening-stock": "Opening stock",
  },
  previewOk: "Preview ok — {count} rows ready.",
  rowIssuesFound: "{count} row issue(s) found.",
  importedRows: "Imported {count} rows.",
  commitIssues: "{message} ({count} row issue(s))",
};
